module.exports = {
  template: require('./owner-registration-requests-container.pug')()
  controller: require('./owner-registration-requests-container.ctrl')
}
